import { render, staticRenderFns } from "./monthFixRecord.vue?vue&type=template&id=47a60990&scoped=true&"
import script from "./monthFixRecord.vue?vue&type=script&lang=js&"
export * from "./monthFixRecord.vue?vue&type=script&lang=js&"
import style0 from "./monthFixRecord.vue?vue&type=style&index=0&id=47a60990&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a60990",
  null
  
)

export default component.exports